let _ENV_CONST;

switch (process.env.NODE_ENV) {

    case 'development':
        _ENV_CONST = {
            ENV: 'development',
            DEBUG: true,
            REACT_APP_MCT_API: "http://staging-sito-ferrarelle.arcww.it/api/mct",
            REACT_APP_FB_APP_ID: "1443189782735860",
            REACT_APP_ANALYTICS_ID: "G-XXXXXXXXXX",
            // REACT_APP_PIWIK_ID: "4f9ff9e6-f0d3-4d34-bcee-00b310ab4dc1",
            // REACT_APP_PIWIK_URL: "https://ferrarelle.containers.piwik.pro",
            REACT_APP_FACEBOOK_PIXEL_ID: "testPixelDev",
            REACT_APP_FACEBOOK_PIXEL_DEBUG: true,
            MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoiZmVycmFyZWxsZSIsImEiOiJja3pxdWUwbGQweXhqMnhwZXJ3dnptYTlxIn0.6xl7zjurD3pS3j_JSJWoZA',
            // MAPBOX_STYLE_URL: 'mapbox://styles/ubiklab/ckzid76el009n14o2hq9vpaqr'
            MAPBOX_STYLE_URL: 'mapbox://styles/mapbox/light-v10'
        }
        break;

    case 'staging':
        _ENV_CONST = {
            ENV: 'staging',
            DEBUG: true,
            REACT_APP_MCT_API: "http://staging-sito-ferrarelle.arcww.it/api/mct",
            REACT_APP_FB_APP_ID: "1443189782735860",
            REACT_APP_ANALYTICS_ID: "G-XXXXXXXXXX",
            // REACT_APP_PIWIK_ID: "4f9ff9e6-f0d3-4d34-bcee-00b310ab4dc1",
            // REACT_APP_PIWIK_URL: "https://ferrarelle.containers.piwik.pro",
            REACT_APP_FACEBOOK_PIXEL_ID: "testPixelStg",
            REACT_APP_FACEBOOK_PIXEL_DEBUG: true,
            MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoiZmVycmFyZWxsZSIsImEiOiJja3pxdWQ2a3czdm0yMnlucnE5OGlpOGx4In0.ozgEJ9K-9oTgMMGwuX3FFA',
            MAPBOX_STYLE_URL: 'mapbox://styles/mapbox/light-v10'
        }
        break;

    case 'production':
        _ENV_CONST = {
            ENV: 'production',
            DEBUG: false,
            REACT_APP_MCT_API: "https://www.ferrarelle.it/api/mct",
            REACT_APP_FB_APP_ID: "702148497063289",
            REACT_APP_ANALYTICS_ID: "G-K87YVCW3N2",
            // REACT_APP_PIWIK_ID: "4f9ff9e6-f0d3-4d34-bcee-00b310ab4dc1",
            // REACT_APP_PIWIK_URL: "https://ferrarelle.containers.piwik.pro",
            REACT_APP_FACEBOOK_PIXEL_ID: "135020387049018",
            REACT_APP_FACEBOOK_PIXEL_DEBUG: false,
            MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoiZmVycmFyZWxsZSIsImEiOiJja3pxdWRsdDgwNnhtMm9tbzIzZ29idnp3In0.EEPX5buwQj8JiKEL2JmHlw',
            MAPBOX_STYLE_URL: 'mapbox://styles/mapbox/light-v10'
        }
        break;

    default:
        _ENV_CONST = {
            ENV: process.env.NODE_ENV,
            DEBUG: process.env.NODE_ENV !== 'production'
        }

}


export const CONST = {

    // environment specific
    ..._ENV_CONST,

    // constants common to all environments
    API: {
        ROUTES: {
            PUBLISHED: {
                CATEGORIES: '/api/categories',
                HP_RECOMMENDED: '/api/restaurants/hp/recommended',
                HP_RESTAURANTS_OF_THE_MONTH: '/api/restaurants/hp/restaurants-of-the-month',
                ALL_RESTAURANTS: '/api/restaurants',
                RESTAURANT: '/api/restaurants/:id'
            },
            PREVIEW: {
                CATEGORIES: '/api/categories',
                HP_RECOMMENDED: '/api/preview/restaurants/hp/recommended',
                HP_RESTAURANTS_OF_THE_MONTH: '/api/preview/restaurants/hp/restaurants-of-the-month',
                ALL_RESTAURANTS: '/api/preview/restaurants',
                RESTAURANT: '/api/preview/restaurants/:id'
            }
        },

    },
    TYPE_OF_RESTAURANTS: {
        COMPONENT: {
            RECOMMENDED: 'recommended',
            RESTAURANTS_OF_THE_MONTH: 'restaurants_of_the_month'
        }
    },
    MAPBOX_SEARCH_ENDPOINT: 'https://api.mapbox.com/geocoding/v5/mapbox.places/'

};

export default CONST;
